import { render, staticRenderFns } from "./UserChangePasswordOwn.vue?vue&type=template&id=6ed2db22&"
import script from "./UserChangePasswordOwn.vue?vue&type=script&lang=js&"
export * from "./UserChangePasswordOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports